import { render, staticRenderFns } from "./PageCookies.vue?vue&type=template&id=42d1cd7a&"
import script from "./PageCookies.vue?vue&type=script&lang=js&"
export * from "./PageCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports